var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ProducerShowsList"}},[_c('QsCard',{attrs:{"qlik-ids":['QweBL'],"card-style":"compact"}}),_c('QsTabs',{attrs:{"qlik-ids":['mmJCq', '3b38ef81-d831-442c-abef-926fc19f63d9'],"date":{ field: 'Jour du spectacle' }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }